import BaseService from '../base';
import { UploadApiAttachment } from './types';

class Upload extends BaseService {
  addFile() {
    return {
      query: <T>(body: T) => ({
        url: this.url,
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: this.tagType, id: 'LIST' }],
    };
  }

  getByRealId() {
    return {
      query: (id: number) => ({
        url: `${this.url}/by_id/${id}`,
        method: 'GET',
      }),
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      providesTags: (result?: UploadApiAttachment) => [{ type: this.tagType }],
    };
  }
}

export default new Upload('uploads', 'Upload');
